/**
 * 待機中に表示するTIPSテキスト
 * ローテーションで順番に表示される
 */
export const CHAT_TIPS = [
  'Tip: You can ask about availability!',
  'Tip: Ask about what to wear or bring for the experience.',
  'Tip: Want to know about group discounts? Just ask!',
  'Tip: You can ask about accessibility and special requirements.',
  'Tip: Ask about the meeting point and how to get there.',
] as const;

export type ChatTip = (typeof CHAT_TIPS)[number];

/**
 * TIPSの表示間隔（ミリ秒）
 */
export const CHAT_TIPS_INTERVAL_MS = 5_000;

/**
 * TIPS表示開始までの遅延（ミリ秒）
 */
export const CHAT_TIPS_DELAY_MS = 2_000;
